import { Accounting, PayoutIntegrationStatus } from 'anchor-scout-common/types';
import { IntegrationFailureModel } from "./IntegrationFailureModel";
export class PayoutIntegrationModel {
  static fromDTO(dto) {
    if (dto.status === PayoutIntegrationStatus.SyncFailed) {
      return new PayoutIntegrationModel({
        status: dto.status,
        syncFailed: new IntegrationFailureModel(dto.syncFailed)
      });
    }
    return new PayoutIntegrationModel(dto);
  }
  static fromAccountingDTO(dtos) {
    const existingIntegrations = dtos.map(dto => ({
      type: dto.type,
      integration: PayoutIntegrationModel.fromDTO(dto.value)
    }));
    const hasQbo = existingIntegrations.some(integration => integration.type === Accounting.QBO);
    const hasXero = existingIntegrations.some(integration => integration.type === Accounting.Xero);
    const defaultIntegrations = [];
    if (!hasQbo) {
      defaultIntegrations.push({
        type: Accounting.QBO,
        integration: new PayoutIntegrationModel({
          status: PayoutIntegrationStatus.PendingSync,
          pendingSync: {
            invoicesReady: false,
            invoicesToSync: [],
            paymentsToSync: []
          }
        })
      });
    }
    if (!hasXero) {
      defaultIntegrations.push({
        type: Accounting.Xero,
        integration: new PayoutIntegrationModel({
          status: PayoutIntegrationStatus.PendingSync,
          pendingSync: {
            invoicesReady: false,
            invoicesToSync: [],
            paymentsToSync: []
          }
        })
      });
    }
    return [...existingIntegrations, ...defaultIntegrations];
  }
  constructor(data) {
    this.data = data;
  }
  isStableStatus() {
    return this.data.status !== PayoutIntegrationStatus.SyncInProgress;
  }
  isSyncFailed() {
    return this.data.status === PayoutIntegrationStatus.SyncFailed;
  }
  isSynced() {
    return this.data.status === PayoutIntegrationStatus.Synced;
  }
  status() {
    return this.data.status;
  }
  isPendingSync() {
    return this.data.status === PayoutIntegrationStatus.PendingSync;
  }
  date() {
    switch (this.data.status) {
      case PayoutIntegrationStatus.SyncFailed:
        return new Date(this.data.syncFailed.date());
      case PayoutIntegrationStatus.Synced:
        return new Date(this.data.synced.date);
      case PayoutIntegrationStatus.Deleted:
        return new Date(this.data.deleted.date);
      case PayoutIntegrationStatus.PendingSync:
      case PayoutIntegrationStatus.SyncInProgress:
        return null;
    }
  }
  invoicesReady() {
    return this.data.status === PayoutIntegrationStatus.PendingSync ? this.data.pendingSync.invoicesReady : null;
  }
  accept(visitor) {
    switch (this.data.status) {
      case PayoutIntegrationStatus.Synced:
        return visitor.whenSynced(this.data.synced);
      case PayoutIntegrationStatus.SyncFailed:
        return visitor.whenSyncFailed(this.data.syncFailed);
      case PayoutIntegrationStatus.PendingSync:
        return visitor.whenPendingSync(this.data.pendingSync);
      case PayoutIntegrationStatus.SyncInProgress:
        return visitor.whenSyncInProgress();
      case PayoutIntegrationStatus.Deleted:
        return visitor.whenDeleted(this.data.deleted);
    }
  }
}